import { makeStyles, alpha, hexToRgb } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  loading: {
    width: "100%",
    height: "100%",
  },
  overlay: {
    position: "absolute",
    transition: "background-Color .2s ease",
    zIndex: -1,
  },
  blur: {
    backgroundColor: alpha(hexToRgb(theme.hv.palette.atmosphere.atmo2), 0.8),
    zIndex: theme.zIndex.drawer,
  },
}));

export default useStyles;
